if (!customElements.get('carousel-slider')) {
	customElements.define('carousel-slider', class CarouselSlider extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.carousel = this.querySelector('.grid-carousel');
			this.flickity = null;
			this.resizeTimer = null;
			this.initialize();
		}

		initialize() {
			if (window.innerWidth >= 750) {
				this.initFlickity();
			}

			window.addEventListener('resize', () => {
				clearTimeout(this.resizeTimer);
				this.resizeTimer = setTimeout(() => {
					if (window.innerWidth < 750 && this.flickity) {
						this.flickity.destroy();
						this.flickity = null;
						this.carousel.style.display = '';
						this.carousel.querySelectorAll('.grid-item').forEach(cell => {
							cell.style.height = '';
							const card = cell.querySelector('.multicolumn-card');
							if (card) card.style.height = '';
						});
					} else if (window.innerWidth >= 750 && !this.flickity) {
						this.initFlickity();
					} else if (this.flickity) {
						this.equalizeHeights();
					}
				}, 150);
			});
		}

		initFlickity() {
			this.carousel.style.display = 'block';
			this.flickity = new Flickity(this.carousel, {
				cellAlign: 'left',
				groupCells: true,
				contain: true,
				resize: true,
				draggable: true,
				prevNextButtons: false,
				fade: false,
				cellSelector: '.grid-item',
				initialIndex: 0,
				pageDots: false,
				wrapAround: false,
				accessibility: false,
			});

			document.fonts.ready.then(() => {
				this.equalizeHeights();
			});

			this.flickity.on('change', (index) => {
				const event = new CustomEvent('slider:slide-change', {
					detail: {
						id: this.getAttribute('id'),
						index,
					},
				});
				document.dispatchEvent(event);
			});
		}

		equalizeHeights() {
			if (!this.flickity) return;
			const cells = this.carousel.querySelectorAll('.grid-item');
			cells.forEach(cell => {
				cell.style.height = 'auto';
				const card = cell.querySelector('.multicolumn-card');
				if (card) card.style.height = 'auto';
			});
			let maxHeight = 0;
			cells.forEach(cell => { maxHeight = Math.max(maxHeight, cell.offsetHeight); });
			cells.forEach(cell => {
				cell.style.height = maxHeight + 'px';
				const card = cell.querySelector('.multicolumn-card');
				if (card) card.style.height = maxHeight + 'px';
			});
			this.flickity.resize();
			const viewport = this.carousel.querySelector('.flickity-viewport');
			if (viewport) viewport.style.height = (parseFloat(viewport.style.height) + 4) + 'px';
		}
	});
}

if (!customElements.get('carousel-navigation')) {
	customElements.define('carousel-navigation', class CarouselNavigation extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.init();
		}

		init(retry = 1, maxRetry = 3) {
			if (retry === maxRetry) {
				return;
			}

			const id = this.getAttribute('for');
			this.carouselComponent = document.querySelector(`#${id}`);

			if ((!this.carouselComponent || !this.carouselComponent.flickity)) {
				setTimeout(() => {
					this.init(retry + 1);
				}, 350);
				return;
			}

			this.flickity = this.carouselComponent.flickity;
			this.buttonPrev = this.querySelector('.js-prev');
			this.buttonNext = this.querySelector('.js-next');

			this.buttonPrev.addEventListener('click', (event) => {
				event.preventDefault();
				this.flickity.previous();
			});

			this.buttonNext.addEventListener('click', (event) => {
				event.preventDefault();
				this.flickity.next();
			});

			this.flickity.on('select', () => {
				this.enableButton(this.buttonPrev);
				this.enableButton(this.buttonNext);

				if (!this.flickity.slides[this.flickity.selectedIndex - 1]) {
					this.disableButton(this.buttonPrev);
				} else if (!this.flickity.slides[this.flickity.selectedIndex + 1]) {
					this.disableButton(this.buttonNext);
				}
			});
		}

		enableButton(button) {
			button.classList.remove('pill-nav-item-disabled');
			button.classList.remove('focus-none');
			button.setAttribute('aria-disabled', 'false');
		}

		disableButton(button) {
			button.classList.add('pill-nav-item-disabled');
			button.classList.add('focus-none');
			button.setAttribute('aria-disabled', 'true');
		}
	});
}
